export const linkStyling: object = {
    '&:hover': {
        color: 'var(--teal_brighter)'
    },
    textDecoration: 'none',
    transition: '.2s',
    color: 'var(--teal)'
};
